<template>
  <div class="mine-no-data">
    <template v-if="!hiddenText">
      <div class="no-list flex-col aic tac">
        <i class="mine-ico img" :class="type"></i>
        <div class="tips">{{tips}}</div>
        <!-- <router-link v-if="!$listeners['link-to'] || !to" :to="to" class="to-home">{{toHomeText}}</router-link>
        <a v-else @click.stop.prevent="$emit('link-to')" class="to-home">{{toHomeText}}</a> -->
        <p class="to-home csp" @click.stop="routerClick">{{toHomeText}}</p>
      </div>
    </template>
    <template v-if="!hiddenList && list.length">
      <div class="user-df-title lh1">{{title}}</div>
      <div class="list flex fww">
        <course-card :item="course" class="course" img-key="bigimg" :image-width="imageWidth" hidden-audio @detail="courseClick"
                     :width="width" :image-height="imageHeight" v-for="(course, j) in list" :key="j"
                     is-custom-label>
          <template #image="{item}">
            <div class="course-image-box">
              <i class="mine-ico poa  audio img spr spirit-icon audio_icon" v-show="item.format_id === 2"></i>
            </div>
          </template>
        </course-card>
      </div>
    </template>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
  export default {
    name: 'MineNoData',
    props: {
      to: {
        type: String,
        default: '/home/page/home'
      },
      type: {
        type: String,
        default: 'tv'
      },
      toHomeText: {
        type: String,
        default: '发现课程'
      },
      tips: {
        type: String,
        default: '暂无内容，快去看看精彩视频吧~'
      },
      hiddenList: {
        type: Boolean,
        default: false
      },
      hiddenText: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: '近期好课'
      },
      imageWidth:{
        type: Number | String,
        default: 199
      },
      imageHeight:{
        type: Number | String,
        default: 119
      },
      width:{
        type: Number | String,
        default: 199
      },
    },
    data() {
      return {
        list: [],
      };
    },
    computed: {
      ...mapGetters(['userInfo']),
    },
    created() {
    },
    mounted() {
      this.getList();
    },
    methods: {
      routerClick(){
        if(this.$listeners['link-to']){
          this.$emit('link-to');
        }else{
          this.OpenRouter(this.to);
        }
      },
      courseClick(item) {
        if (this.$listeners.detail) {
          this.$emit('detail', item);
        } else {
          this.OpenRouter(`/home/${item.format_id === 1 ? 'video' : 'audio'}/details/${item.id}/${item.type}`);
        }
      },
      getList() {
        if (this.hiddenList) return;
        this.http.NEWCourse({...this.Product}).then(res => {
          if (res.list.length) {
            this.list = res.list.slice(0, 8);
          } else {
            this.getHotCourse();
          }
        }).catch(this.$err);
      },
      getHotCourse() {
        this.http.NEWCoursePlayRanking({format_id: 1, ...this.Product, is_web: 1, uid: this.userInfo.uid}).then(res => {
          this.list = res.list.slice(0, 8);
          this.title = '本月热播榜';
        }).catch(this.$err);
      }
    }
  }
</script>

<style scoped lang="less">
  @import '../../../assets/less/function';

  .spirit-icon {
    .spirit(url(../../../assets/images/search_icon.png));
    &.audio_icon {
      opacity: 0.5;
      &:after {
        width: 25px;
        height: 25px;
        background-position: -77px -2px;
      }
    }
  }

  .no-list {
    padding: 72px 0;
    font-size: 14px;
    .tips {
      margin: 20px 0 25px;
      color: #999fa6;
    }
    .to-home {
      width: 90px;
      height: 30px;
      line-height: 30px;
      border-radius: 30px;
      color: #fff;
      background-color: #1177ff;
      text-decoration: none;
      &:hover {
        background-color: #0066ed;
      }
    }
  }

  .title {
    margin-bottom: 24px;
    padding: 16px 0 0 14px;
    font-size: 26px;
    color: #333f4e;
  }

  .course-image-box {
    .audio {
      left: 8px;
      bottom: 5px;
    }
    .hover-box {
      cursor: unset;
      background-color: rgba(0, 15, 34, 0.5);
    }
    .hover-delete {
      top: 6px;
      right: 8px;
    }
    .edit-checkbox {
      height: 32px;
      line-height: 0;
      background: linear-gradient(180deg, rgba(0, 15, 34, 0.5), rgba(0, 15, 34, 0));
      .mine-ico {
        right: 8px;
      }
    }
  }

  .list {
    margin-left: -16px;
  }

  .course-card {
    margin: 0 0 24px 16px;
    align-items: unset;
    &:hover {
      /deep/ .resources_name {
        color: #999fa6;
      }
    }
    /deep/ .name {
      font-size: 16px;
    }
    /deep/ .resources_name {
      padding-top: 10px;
      font-size: 14px;
      color: #999fa6;
    }
    /deep/ .detail-box {
      padding: 0;
    }
    // /deep/ .vip-type-tip {
    //   display: none;
    // }
  }
</style>